import React, { useEffect, useState } from "react";
import axios from "axios";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const OrderSuccess = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user?._id;
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    if (!userId) return;

    const fetchOrders = async () => {
      try {
        const res = await axios.get(
          `https://mediapi.onlinepharmaque.in/api/v1/orders/${userId}`
        );
        setOrders(res.data);
      } catch (error) {
        console.log(error);
      }
    };

    fetchOrders();
  }, [userId]);

  return (
    <div className="min-h-screen bg-gray-50 px-3 py-4">

      {/* BACK BUTTON */}
      <div className="mb-3">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 text-gray-600 hover:text-[#187685]"
        >
          <ArrowLeft size={18} />
          <span className="text-sm font-medium">Back</span>
        </button>
      </div>

      {/* TITLE */}
      <h1 className="text-xl font-semibold text-center text-[#187685] mb-5">
        🎉 Your Orders
      </h1>

      {/* FULL WIDTH CONTAINER */}
      <div className="w-full space-y-4">

        {orders.map((order) => (
          <div
            key={order._id}
            className="bg-white rounded-xl p-4 shadow-sm border"
          >

            {/* ORDER HEADER */}
            <div className="flex justify-between items-center mb-3">
              <h2 className="text-[#187685] font-medium text-sm">
                Order ID: {order._id}
              </h2>

              <span className="text-xs bg-[#187685]/10 text-[#187685] px-2 py-1 rounded-full">
                Delivered
              </span>
            </div>

            {/* ITEMS */}
            <div className="space-y-3">
              {order.items.map((item) => (
                <div
                  key={item._id}
                  className="flex items-center justify-between bg-gray-50 rounded-lg p-3"
                >

                  {/* LEFT */}
                  <div className="flex items-center gap-3">

                    <div className="bg-white p-1 rounded-md shadow-sm">
                      <img
                        src={`https://mediapi.onlinepharmaque.in/uploads/${item.img}`}
                        alt={item.name}
                        className="w-14 h-14 object-contain"
                      />
                    </div>

                    <div>
                      <h3 className="font-medium text-sm text-gray-800">
                        {item.name}
                      </h3>
                      <p className="text-xs text-gray-500">
                        ₹ {item.price}
                      </p>
                    </div>

                  </div>

                  {/* RIGHT */}
                  <div className="flex items-center gap-2">

                    <button className="bg-[#187685] text-white px-3 py-1.5 rounded-md text-xs">
                      Reorder
                    </button>

                    <button className="border border-[#187685] text-[#187685] px-3 py-1.5 rounded-md text-xs">
                      View
                    </button>

                  </div>

                </div>
              ))}
            </div>

          </div>
        ))}

      </div>

    </div>
  );
};

export default OrderSuccess;